// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import vant from 'vant';
import store from './store/store.js';
import 'vant/lib/index.css';
import './common/common.css';
import { Lazyload } from 'vant';
import axios from 'axios'
import api from './common/api-urls.js';
import qs from 'qs';
import util from './common/util.js';
import Config from './common/Config.js';
import Cookies from 'js-cookie';

console.log(util.urlget("orgid"), Cookies.get("orgid"))
//根据不同水司ID获取相应的水司对应信息
let newConfig = {};
if(util.urlget("orgid") || Cookies.get("orgid")) {
	let orgid = util.urlget("orgid") || Cookies.get("orgid");
	Cookies.set("orgid", orgid, {
		expires: 7
	});
	for(let i = 0; i < Config.length; i++) {
		if(Config[i].orgid == orgid) {
			newConfig = JSON.parse(JSON.stringify(Config[i]))
		}
	};
	api.orgid = newConfig.orgid;
}
//根据不同水司ID获取相应的水司对应信息

Vue.prototype.qs = qs;
Vue.prototype.axios = axios;
Vue.prototype.api = api;
Vue.prototype.util = util;
Vue.prototype.$Config = newConfig;
Vue.prototype.$cookie = Cookies;
Vue.config.productionTip = false;
Vue.use(vant);
Vue.use(Lazyload);
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	store,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js